<template>
  <div class="">
    <line-chart
      chartId="report"
      ref="chart"
      :height="400"
      :options="options"
      :not-merge="true"
      @update-axis-pointer="updateAxis"
      @lock="lockAxisPointer"
    ></line-chart>

    <div class="report-expand">
      <card-list
        :insects="cardData"
        :date="date"
        :colors="colors"
        :checked="checked"
        @change="insectChange"
      ></card-list>

      <img-list
        :loading="imLoading"
        :title="imgTitle"
        :imgs="imgs"
        :cates="cates"
        :checked="cateChecked"
        :statistic="statistic"
        :current="current"
        :devs="avaibleDevs"
        :group-type="groupType"
      ></img-list>
    </div>
  </div>
</template>

<script>
import merge from 'lodash.merge'
import LineChart from '@/components/Chart'
import ImgList from './imgList'
import { getImgsV2 } from '@/service/telemetry'
import sleep from '@/utlis/sleep'
import moment from 'moment'
import CardList from './cards'

export default {
  components: { LineChart, CardList, ImgList },
  props: {
    colors: Array,
    data: Array,
    cates: Array,
    devs: Array,
    opts: Object,
    actived: Number,
    groupType: String
  },
  data() {
    return {
      checked: [],
      imgs: [],
      imgTitle: '',
      date: '',
      imLoading: false
    }
  },
  computed: {
    active() {
      if (this.groupType === 'device') {
        return this.devs[this.actived] || {}
      } else {
        const cate = this.cates[this.actived] || {}
        const c = this.categories.find(o => o.name === cate.name)
        return c || {}
      }
    },
    avaibleDevs() {
      return this.devs.filter((d, idx) => {
        return this.groupType === 'device'
          ? idx === this.actived
          : this.checked.includes(idx)
      })
    },
    options() {
      const opts = this.getOptions(this.colors)
      const dataset = this.getDataset(this.groupType, this.data, this.active)
      const series = this.getSeries(this.groupType, this.active)

      return merge({}, opts, { dataset, series })
    },
    cardData() {
      if (this.groupType === 'device') {
        return this.cates.map(c => {
          let datasets = {}

          this.data.forEach(d => {
            const dd = d.devices.find(dev2 => dev2.id === this.active.id)
            const cate = dd.categories.find(cate => cate.name === c.name)
            datasets[d.date] = cate.qty || 0
          })
          const total = Object.values(datasets).reduce(
            (total, cur) => total + cur,
            0
          )
          return { name: c.name, total, datasets }
        })
      } else {
        return this.devs.map(d => {
          let datasets = {}
          this.data.forEach(dd => {
            const dev = dd.devices.find(ddd => ddd.id === d.id)
            const insect = dev.categories.find(c => c.name === this.active.name)
            datasets[dd.date] = insect ? insect.qty : 0
          })

          const total = Object.values(datasets).reduce(
            (total, cur) => total + cur,
            0
          )

          return { name: d.name, total, datasets }
        })
      }
    },
    cateChecked() {
      return this.groupType === 'device' ? this.checked : [this.actived]
    },
    sumarry() {
      let { source } = this.options.dataset
      return source.map(s => {
        let sum = this.checked.reduce((total, idx) => total + s[idx + 1], 0)
        return { date: s[0], total: sum }
      })
    },
    statistic() {
      let max = { date: '', total: 0 }
      let first = { date: '', total: 0 }
      this.sumarry.forEach(row => {
        if (!max.date || row.total >= max.total) {
          max = row
        }
        if (!first.date || (row.total > 0 && first.total === 0)) {
          first = row
        }
      })
      return { max, first }
    },
    current() {
      let row = this.sumarry.find(row => this.imgTitle === row.date)
      return row ? row : { date: '', total: 0 }
    },
    statisticPrev() {
      return this.$store.getters.statisticPrev
    }
  },
  mounted() {
    if (this.data && this.data[0]) {
      this.dateChange(this.data[0].date)
      this.initChecked()
      this.initImgs()
    }
  },
  methods: {
    insectChange(idx) {
      const groups = this.groupType === 'device' ? this.cates : this.devs
      const name = groups[idx] ? groups[idx].name : ''

      if (this.checked.length === this.cardData.length) {
        this.checked = [idx]
        this.$refs.chart.select(name)
      } else {
        const index = this.checked.findIndex(i => i === idx)
        if (index >= 0 && this.checked.length === 1) {
          this.initChecked()
          this.$refs.chart.selectAll()
        } else if (index >= 0) {
          this.checked.splice(index, 1)
          this.$refs.chart.selectToggle(name)
        } else {
          this.checked.push(idx)
          this.$refs.chart.selectToggle(name)
        }
      }
    },
    initChecked() {
      this.checked = this.cardData.map((_, idx) => idx)
    },
    initImgs() {
      this.imgTitle = ''
      this.imgs = []
    },
    dateChange(date) {
      this.date = date
    },
    updateAxis(e) {
      const dataIndex = e.dataIndex
      if (dataIndex >= 0 && this.data.length >= dataIndex + 1) {
        if (this.date !== this.data[dataIndex].date) {
          this.dateChange(this.data[dataIndex].date)
        }
      }
    },

    getDataset(type, data, active) {
      if (type === 'device') {
        const dimensions = ['日期'].concat(this.cates.map(c => c.name))
        const source = data.map(r => {
          const device = r.devices.find(d => d.id === +active.id)
          return [r.date].concat(device.categories.map(c => c.qty))
        })
        return { dimensions, source }
      } else {
        const dimensions = ['日期'].concat(this.devs.map(c => c.name))
        const source = data.map(d => {
          return [d.date].concat(
            d.devices.map(dd => {
              const insect = dd.categories.find(c => c.name === active.name)
              return insect ? insect.qty : 0
            })
          )
        })

        return { dimensions, source }
      }
    },
    getOptions(colors) {
      return {
        title: { show: false },
        legend: { show: false },
        color: colors,
        tooltip: {
          trigger: 'axis',
          position: function(point) {
            return [point[0] + 20, 20]
          }
        },
        grid: {
          show: false,
          top: 32,
          bottom: 60,
          right: 100
        },
        xAxis: { type: 'category', triggerEvent: false, silent: true },
        yAxis: { type: 'value' },
        dataZoom: [
          {
            show: true,
            bottom: 12,
            right: 100
          }
        ]
      }
    },
    getSeries(type, active) {
      if (type === 'device') {
        return active && active.categories
          ? active.categories.map(c => ({
              type: 'line',
              smooth: true,
              // stack: true,
              name: c.name
            }))
          : []
      } else {
        return this.devs.map(d => ({
          type: 'line',
          smooth: true,
          // stack: true,
          name: d.name
        }))
      }
    },
    lockAxisPointer(idx) {
      if (idx >= 0 && this.groupType === 'device') {
        let date = this.date
        if (this.imgTitle === date) return
        this.imgTitle = date
      } else {
        let date = this.date
        if (this.imgTitle === date) return
        this.imgTitle = date
      }
    },

    async getImgs(query) {
      this.imLoading = true
      let [
        {
          data: { insects, pictures: imgs }
        }
      ] = await Promise.all([getImgsV2(query), sleep(1)])
      this.imgs = imgs.map(i => {
        return { ...i, insects: insects.filter(o => o.pictureId === i.id) }
      })
      this.imLoading = false
    }
  },
  watch: {
    active() {
      this.initImgs()
    },
    data(d) {
      if (d && d[0]) {
        this.dateChange(d[0].date)
      }
    },
    groupType() {
      this.initChecked()
    },
    cardData() {
      this.initChecked()
    },
    sumarry() {
      this.$nextTick(() => {
        this.imgTitle = this.statistic.max.date
      })
    },
    imgTitle(date) {
      if (date) {
        let m = this.statisticPrev ? moment(date) : moment(date).add(1, 'days')
        let endDate = m.format('YYYY-MM-DDT00:00:00[Z]')
        let beginDate = m.subtract(1, 'days').format('YYYY-MM-DDT08:00:00[Z]')
        this.getImgs({
          beginDate,
          endDate,
          keys:
            this.groupType === 'device'
              ? this.active.key
              : this.devs.map(d => d.key).join(','),
          limit: 200
        })
      }
    }
  }
}
</script>

<style lang="css" scoped></style>
